import React from 'react';
import StructuredData from './StructuredData';

/**
 * Generate schema.org BreadcrumbList structured data
 * @param {Array} items - Array of breadcrumb items with name and path properties
 * @param {string} basePath - The base URL path (defaults to https://globetune.co.uk)
 */
const BreadcrumbSchema = ({ items, basePath = 'https://globetune.co.uk' }) => {
  // Always include home as the first item if not already included
  const breadcrumbItems = items.length > 0 && items[0].name === 'Home' 
    ? items 
    : [{ name: 'Home', path: '/' }, ...items];
  
  // Convert items array to the format expected by the StructuredData component
  const breadcrumbData = breadcrumbItems.map(item => ({
    name: item.name,
    url: `${basePath}${item.path}`
  }));
  
  return <StructuredData type="BreadcrumbList" data={breadcrumbData} />;
};

export default BreadcrumbSchema; 